<template>
    <div class="clients">
        <section class="bg_clientes">
            <div class="section cases clients-fullpage">
                <div class="section" v-for="page in records.pages">
                    <div class="container">
                        <div class="flip" v-for="client in page.clients" @click="toggleClass($event)">
                            <div class="card">
                                <div class="face front">
                                    <img class="img-responsive" :src="client.logo" :alt="client.alt">
                                </div>
                                <div class="face back">
                                    <div class="d_table h_full">
                                        <div class="d_table_cell">
                                            <h4>{{ client.client }}</h4>
                                            <span>{{ client.description[getLang] }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import jQuery from 'jquery'
    import { fullpage } from 'fullpage.js/dist/jquery.fullpage'
    import { getLang } from '../vuex/settings/getters'

    export default {
        name: 'Clients',
        data () {
            return {
                records: require('../data/clients.json'),
                meta: {
                    title: 'Clientes, parceiros e amigos',
                    description: 'Conheça os clientes, parceiros e amigos que ajudam a construir nossa história',
                    pageUrl: 'http://www.guco.com.br/clientes',
                }
            }
        },
        head: {
            title () {
                return {
                    inner: this.meta.title
                }
            },
            meta () {
                return {
                    // Basic meta
                    name: {
                        'description' : this.meta.description,
                        'twitter:title': this.meta.title + ' | ' + this.meta.appName,
                        'twitter:description': this.meta.description,
                    },
                    // Google+ / Schema.org
                    itemprop: {
                        name: this.meta.title + ' | ' + this.meta.appName,
                        description: this.meta.description,
                    },
                    // Facebook / Open Graph
                    property: {
                        'og:url': this.meta.pageUrl,
                        'og:title': this.meta.title + ' | ' + this.meta.appName,
                        'og:description': this.meta.description,
                    }
                }
            },
            link () {
                return {
                    canonical: {
                        href: this.meta.pageUrl
                    },
                }
            }
        },
        vuex: {
            getters: {
                getLang
            }
        },
        detached () {
            jQuery.fn.fullpage.destroy('all');
        },
        ready () {
            jQuery('.clients-fullpage').fullpage({
                anchors: ['clients 01', 'clients 02', 'clients 03', 'clients 04'],
                lockAnchors: true,
                css3: true,
                navigation: true,
                navigationPosition: 'right',
                responsiveWidth: 993,
                responsiveHeight: 500
            });
        },
        methods: {
            toggleClass (e) {
                jQuery(e.target).parents('.flip').toggleClass('active');
            }
        },
    }
</script>



// WEBPACK FOOTER //
// Clients.vue?9383890e